import React from 'react'
import Table from "react-bootstrap/Table";

export default function AllRateTable(props) {

  const {data} = props  
  const formatCurrency = (value) => {
    const normalizedValue = Number(value);
    if (!Number.isFinite(normalizedValue)) return '0.00';
    return normalizedValue.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  return (
    <Table striped bordered className="report table-sm">
        <thead>
            <tr className="table-warning">
                <th>In</th>
                <th>Out</th>
                <th>Day</th>
                <th>Date</th>
                <th>Total</th>
            </tr>
        </thead>
        <tbody>
            {data && (data).map((record, index) => {
                const outDate = record.outdate ? record.outdate.split('T')[0] : '';
                return (
                    <tr key={index} >
                        <td>{record.carsIn}</td>
                        <td>{record.outCars}</td>
                        <td>{record.dayofweek}</td>
                        <td>{outDate}</td>
                        <td>${formatCurrency(record.total)}</td>
                    </tr>
                );
            })}
        </tbody>
    </Table>
  )
}
